export default "__VITE_ASSET__D6yZXFF2__"